// extracted by mini-css-extract-plugin
export default {"north":"PanoramaCompass_north__qZbQq","south":"PanoramaCompass_south__wBkRM","east":"PanoramaCompass_east__mY9R-","west":"PanoramaCompass_west__dfu1D"};